module.exports = __webpack_public_path__ + "static/img/select-mark.0578499a.png";